import { filter, take, takeUntil } from 'rxjs/operators';
import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Constant } from '../constant/constant';
import { InvoiceGenaratorService } from '../services/invoice-genarator.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../services/common.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { TourService } from '../modules/tour/services/tour.service';
import { ORIGINAL_COUNTRIES } from '../shared/data/countries';
import { CountryStateCityService } from '../services/country-state-city.service';
import { CountryLocationService } from '../services/country-location.service';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { DashboardPopupComponent } from '../pages/auth/dashboard-popup/dashboard-popup.component';
import { AccountsService } from '../services/accounts.service';
import { noWhitespaceValidator } from '../shared/utils/calsoft-validators';


const phoneUtil = PhoneNumberUtil.getInstance();

@Component({
  selector: 'calsoft-whatapp-integration-popup',
  templateUrl: './whatapp-integration-popup.component.html',
  styleUrls: ['./whatapp-integration-popup.component.scss']
})
export class WhatappIntegrationPopupComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';

  url = '';
  currentStep = 1;

  businessForm!: FormGroup;
  personalizationForm!: FormGroup;
  prerequisitesForm!: FormGroup;

  data: any;

  originalCountries = ORIGINAL_COUNTRIES;
  filteredCountries: { id: string; name: string; flag: string }[] = [];
  searchControl = new FormControl();
  isLoadingCountryCode = false;

  // Country / State / City cascade
  locationCountries: any[] = [];
  locationStates: any[] = [];
  locationCities: any[] = [];
  filteredLocationCountries: any[] = [];
  filteredLocationStates: any[] = [];
  filteredLocationCities: any[] = [];
  selectedCountryId: any = null;
  selectedStateId: any = null;
  selectedCityId: any = null;
  countrySearchControl = new FormControl();
  stateSearchControl = new FormControl();
  citySearchControl = new FormControl();

  geoData: any = null;

  constructor(private _formBuilder: FormBuilder,
    private router: Router,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private tourService: TourService,
    private countryStateCityService: CountryStateCityService,
    private countryLocationService: CountryLocationService,
    private accountService: AccountsService,
    @Inject(MAT_DIALOG_DATA) data,
    private dialogRef: MatDialogRef<WhatappIntegrationPopupComponent>,
  ) {

    this.data = data || {};
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });

    this.initForms();
    this.setDefaultPhoneCountryCode();

    this.filteredCountries = this.originalCountries;
    this.searchControl.valueChanges.subscribe(value => {
      this.filterCountries(value);
    });

    // Validate phone number on each keystroke
    this.businessForm.get('phoneNo')?.valueChanges.subscribe(value => {
      if (value) this.validatePhoneNumber(value);
    });
  }

  plan: any;

  get showSampleDataStep(): boolean {
    const allowedPlans = ['18', '12', '13', '6', '15', '24', '23'];
    return allowedPlans.includes(String(this.plan));
  }

  accountList: any = [];

  ngOnInit(): void {

    this.plan = localStorage.getItem("plan");

    this.loadGeoData();
    this.getAccountData();
    this.loadLocationCountries();
    this.onLocationCountrySearch();
    this.onLocationStateSearch();
    this.onLocationCitySearch();
  }


  getAccountData() {
    this.accountService.getAllAccountsBYtenant().subscribe(
      data => {


        this.accountList = data;

        if (this.accountList.length > 0) {

          console.log("accountList", this.accountList);


        }

      }

    )
  }


  preventLeadingSpace(event: any): void {
    if (event.key === ' ' && (!event.target.value || event.target.selectionStart === 0)) {
      event.preventDefault();
    }
  }

  preventAllSpace(event: any): void {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }

  preventDotAndComma(event: any): void {
    if (event.key === '.' || event.key === ',') {
      event.preventDefault();
    }
  }


  initForms(): void {

    this.businessForm = this._formBuilder.group({
      name: ['', [Validators.required, noWhitespaceValidator]],
      countrycode: ['91', Validators.required],
      phoneNo: ['', Validators.required],
      website: ['', Validators.pattern(/^\S*$/)],
      location: ['', Validators.required],
      state: ['', Validators.required],
      city: [''],
      organizationSize: ['1 - 50', Validators.required],
      howDidYouHear: ['Google', Validators.required]
    });


    this.personalizationForm = this._formBuilder.group({
      role: ['Founder', Validators.required],
      industry: ['Education', Validators.required],
      modules: [['leads', 'deals', 'companies', 'activities']]
    });

    this.prerequisitesForm = this._formBuilder.group({
      ready: [false, Validators.requiredTrue]
    });
  }

  nextStep(): void {
    if (this.currentStep === 1 && this.businessForm.invalid) {
      this.businessForm.markAllAsTouched();
      return;
    }

    if (this.currentStep === 2 && this.personalizationForm.invalid) {
      this.personalizationForm.markAllAsTouched();
      return;
    }

    // if (this.plan === "6" || this.plan === "18") {
    //   if (this.currentStep < 2) {
    //     this.currentStep++;
    //   }
    //   this.confirm();
    //   return;
    // }

    // if (this.currentStep === 4 && this.prerequisitesForm.invalid) {
    //   this.prerequisitesForm.markAllAsTouched();
    //   return;
    // }

    if (this.currentStep === 2) {
      if (!this.showSampleDataStep) {
        this.buttonText = 'Processing';
        this.confirm();
        return;
      }
    }

    if (this.currentStep < 3) {
      this.currentStep++;
    }
  }


  previousStep(): void {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }

  filterCountries(value: string): void {
    if (!value) {
      this.filteredCountries = this.originalCountries.slice();
    } else {
      this.filteredCountries = this.originalCountries.filter(country =>
        country.name.toLowerCase().includes(value.toLowerCase())
      );
    }
  }

  /**
   * Detects the user's country calling code from IP geolocation (stored in localStorage).
   * Sets the `countrycode` form control to the matching ORIGINAL_COUNTRIES id.
   * Falls back to India (+91, id='75') if detection fails.
   */
  setDefaultPhoneCountryCode(): void {
    try {
      const raw = localStorage.getItem(Constant.COUNTRY_LOCATION);
      if (raw) {
        const geo = JSON.parse(raw);
        // ipapi.co returns country_calling_code like "+91", ipinfo returns country ISO2
        const callingCode = (geo.country_calling_code || '').replace('+', '');
        const iso2 = (geo.country_code || geo.country || '').toUpperCase();

        let matched: any = null;

        if (callingCode) {
          matched = this.originalCountries.find(c => {
            const parts = c.name.split('+');
            return parts.length > 1 && parts[1].trim() === callingCode;
          });
        }

        if (!matched && iso2) {
          // fallback: match by ISO2 country name prefix (e.g., "India +91" starts with "India")
          matched = this.originalCountries.find(c =>
            c.name.toUpperCase().startsWith(iso2)
          );
        }

        if (matched) {
          this.businessForm.get('countrycode')?.setValue(matched.id);
          return;
        }
      }
    } catch (e) {
      console.warn('setDefaultPhoneCountryCode: failed to detect country', e);
    }
    // Default to India
    this.businessForm.get('countrycode')?.setValue('75');
  }

  getCountryCode(value: string): string {
    if (!value) return '+91';
    const country = this.originalCountries?.find(x => x.id === value);
    if (country) {
      const parts = country.name.split('+');
      if (parts.length > 1) return `+${parts[1].trim()}`;
    }
    return '+91';
  }

  onCountrySelectionChange(event: any): void {
    this.businessForm.get('phoneNo')?.reset();
    this.businessForm.get('phoneNo')?.setValidators([Validators.required]);
    this.businessForm.get('phoneNo')?.updateValueAndValidity();
  }

  validatePhoneNumber(text: string): void {
    const phoneCtrl = this.businessForm.get('phoneNo');
    if (!phoneCtrl) return;

    const countryId = this.businessForm.get('countrycode')?.value;
    const countryEntry = this.originalCountries.find(x => x.id === countryId);
    if (!countryEntry) return;

    const match = countryEntry.flag.match(/\/([a-z]{2})\.png$/);
    const iso2 = match ? match[1].toUpperCase() : null;
    if (!iso2) return;

    try {
      const number = phoneUtil.parse(text, iso2);
      const isValid = phoneUtil.isValidNumberForRegion(number, iso2);
      if (!isValid) {
        phoneCtrl.setErrors({ customError: true });
        phoneCtrl.markAsTouched();
      } else {
        phoneCtrl.setErrors(null);
      }
    } catch {
      phoneCtrl.setErrors({ customError: true });
      phoneCtrl.markAsTouched();
    }
  }

  loadGeoData(): void {
    try {
      const raw = localStorage.getItem(Constant.COUNTRY_LOCATION);
      if (raw) {
        this.geoData = JSON.parse(raw);
      }
    } catch (e) {
      console.warn('Failed to parse geo location data', e);
    }
  }

  loadLocationCountries(): void {
    this.countryStateCityService.getAllCountries()
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        res => {
          this.locationCountries = res;
          this.filteredLocationCountries = res;
          this.autoSelectCountry();
        },
        err => console.error('Error loading countries', err)
      );
  }

  onLocationCountrySearch(): void {
    this.countrySearchControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((searchText: string) => {
        if (!searchText) {
          this.filteredLocationCountries = this.locationCountries;
        } else {
          const lower = searchText.toLowerCase();
          this.filteredLocationCountries = this.locationCountries.filter(c =>
            c.name?.toLowerCase().includes(lower)
          );
        }
      });
  }

  onLocationCountryChange(event: any): void {
    const selectedCountry = event.value;
    if (selectedCountry) {
      const countryObj = this.locationCountries.find(c => c.name?.toLowerCase() === selectedCountry.toLowerCase());
      this.selectedCountryId = countryObj ? (countryObj.id || countryObj) : selectedCountry;

      this.locationStates = [];
      this.locationCities = [];
      this.filteredLocationStates = [];
      this.filteredLocationCities = [];
      this.selectedStateId = null;
      this.selectedCityId = null;

      this.businessForm.get('state')?.reset();
      this.businessForm.get('city')?.reset();

      this.loadLocationStates(this.selectedCountryId);
    }
  }

  autoSelectCountry(): void {
    if (!this.geoData?.country_name) return;
    const match = this.locationCountries.find(c =>
      c.name?.toLowerCase() === this.geoData.country_name.toLowerCase()
    );
    if (match) {
      this.businessForm.get('location')?.setValue(match.name);
      this.selectedCountryId = match.id || match;
      this.loadLocationStates(this.selectedCountryId);
    }
  }

  loadLocationStates(countryId: any): void {
    this.countryStateCityService.getStatesByCountry(countryId)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        res => {
          this.locationStates = res;
          this.filteredLocationStates = res;
          this.autoSelectState();
        },
        err => console.error('Error loading states', err)
      );
  }

  onLocationStateSearch(): void {
    this.stateSearchControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((searchText: string) => {
        if (!searchText) {
          this.filteredLocationStates = this.locationStates;
        } else {
          const lower = searchText.toLowerCase();
          this.filteredLocationStates = this.locationStates.filter(s =>
            s.name?.toLowerCase().includes(lower)
          );
        }
      });
  }

  onLocationStateChange(event: any): void {
    const selectedState = event.value;
    if (selectedState && this.selectedCountryId) {
      const stateObj = this.locationStates.find(s => s.name?.toLowerCase() === selectedState.toLowerCase());
      this.selectedStateId = stateObj ? (stateObj.id || stateObj) : selectedState;

      this.locationCities = [];
      this.filteredLocationCities = [];
      this.selectedCityId = null;
      this.businessForm.get('city')?.reset();

      this.loadLocationCities(this.selectedCountryId, this.selectedStateId);
    }
  }

  autoSelectState(): void {
    if (!this.geoData?.region) return;
    const match = this.locationStates.find(s =>
      s.name?.toLowerCase() === this.geoData.region.toLowerCase()
    );
    if (match) {
      this.businessForm.get('state')?.setValue(match.name);
      this.selectedStateId = match.id || match;
      this.loadLocationCities(this.selectedCountryId, this.selectedStateId);
    }
  }

  loadLocationCities(countryId: any, stateId: any): void {
    this.countryStateCityService.getCitiesByState(countryId, stateId)
      .pipe(takeUntil(this._onDestroy))
      .subscribe(
        res => {
          this.locationCities = res;
          this.filteredLocationCities = res;
          this.autoSelectCity();
        },
        err => console.error('Error loading cities', err)
      );
  }

  autoSelectCity(): void {
    if (!this.geoData?.city) return;
    const match = this.locationCities.find(c =>
      c.name?.toLowerCase() === this.geoData.city.toLowerCase()
    );
    if (match) {
      this.businessForm.get('city')?.setValue(match.name);
      this.selectedCityId = match.id || match;
    }
    // Clear geoData so manual country/state changes don't re-trigger auto-fill
    this.geoData = null;
  }

  onLocationCitySearch(): void {
    this.citySearchControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((searchText: string) => {
        if (!searchText) {
          this.filteredLocationCities = this.locationCities;
        } else {
          const lower = searchText.toLowerCase();
          this.filteredLocationCities = this.locationCities.filter(c =>
            c.name?.toLowerCase().includes(lower)
          );
        }
      });
  }

  onLocationCityChange(event: any): void {
    const cityObj = this.locationCities.find(c => c.name?.toLowerCase() === event.value?.toLowerCase());
    this.selectedCityId = cityObj ? (cityObj.id || cityObj) : event.value;
  }

  selectOrgSize(size: string): void {
    this.businessForm.get('organizationSize')?.setValue(size);
  }

  selectRole(role: string): void {
    this.personalizationForm.get('role')?.setValue(role);
  }

  selectIndustry(industry: string): void {
    this.personalizationForm.get('industry')?.setValue(industry);
  }

  availableModules = [
    { key: 'leads', label: 'Leads' },
    { key: 'deals', label: 'Deals' },
    { key: 'companies', label: 'Companies' },
    { key: 'activities', label: 'Activities' }
  ];

  toggleModule(moduleKey: string): void {
    const current: string[] = this.personalizationForm.get('modules')?.value || [];
    const updated = current.includes(moduleKey)
      ? current.filter(m => m !== moduleKey)
      : [...current, moduleKey];
    this.personalizationForm.get('modules')?.setValue(updated);
  }

  isModuleSelected(moduleKey: string): boolean {
    const current: string[] = this.personalizationForm.get('modules')?.value || [];
    return current.includes(moduleKey);
  }

  skipImport(): void {

    this.confirm();
  }

  importSampleData(): void {
    const industry = this.personalizationForm.get('industry')?.value;
    const modules: string[] = this.personalizationForm.get('modules')?.value || [];

    if (!industry) {
      this.snackBar.open('Please select an industry.', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      return;
    }

    const payload = { industry };

    this.importText = 'Processing';
    this.commonService.importSampleData(payload).subscribe(
      (response) => {
        this.importText = 'Yes, Import Data';
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open('Sample data imported successfully', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
        } else {
          this.snackBar.open(response['status_message'] || 'Import failed', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
      },
      () => {
        this.importText = 'Yes, Import Data';
        this.snackBar.open('Sample data import failed', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
      }
    );
    this.confirm();
  }

  isSubmitting = false;
  buttonText: string = 'Continue';
  importText: string = 'Yes, Import Data';

  source: any = "crmSignup";

  confirm() {
    if (this.isSubmitting) {
      return;
    }

    if (this.businessForm.invalid || this.personalizationForm.invalid) {
      this.businessForm.markAllAsTouched();
      this.personalizationForm.markAllAsTouched();
      return;
    }

    const formData = {
      ...this.businessForm.value,
      ...this.personalizationForm.value,
      ...(this.plan !== "6" && this.plan !== "18" ? this.prerequisitesForm.value : {})
    };

    if (this.plan == "16") {
      this.source = "whatsappSignup"
    } else {
      this.source = "onboarding"
    }

    this.isSubmitting = true;
    this.buttonText = 'Processing';
    this.commonService.submitResponse(formData, this.source).subscribe(
      (response) => {
        this.isSubmitting = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.buttonText = 'Continue';
          const accountId = this.accountList[0];

          localStorage.setItem("formSubmitted", "0");
          localStorage.setItem("whatsappCreated", "2");
          localStorage.setItem("userCreated", "1");

          if (accountId) {
            const businessType = this.personalizationForm.get('industry')?.value;
            this.updateAccount(accountId, businessType);
          }

          this.dialogRef.close(true);
        }
        else {
          this.buttonText = 'Continue';
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
      },
      (err) => {
        this.isSubmitting = false;
        this.buttonText = 'Continue';
      });

  }


  enableTour() {
    this.tourService.startTour();
  }

  updateAccount(account: any, businessType: string) {
    const payload = {
      accountId: account.accountId,
      businessType: businessType
    };
    this.commonService.saveUpdate(payload).subscribe(
      (response) => {
      },
      (err) => {

      });
  }

  close() {
    this.dialogRef.close();
  }

  openDashboardPopup(): void {
    const dialogConfig: any = {
      height: '100vh',
      maxHeight: '100vh',
      disableClose: true,
      panelClass: 'dashboard-drawer-dialog'
    };

    if (window.innerWidth < 768) {
      dialogConfig.width = '100vw';
      dialogConfig.maxWidth = '100vw';
      dialogConfig.position = { top: '0' };
    } else {
      dialogConfig.width = '550px';
      dialogConfig.maxWidth = '550px';
      dialogConfig.position = { right: '0', top: '0' };
    }

    this.dialogRef.afterClosed().pipe(take(1)).subscribe(() => {
      this.dialog.open(DashboardPopupComponent, dialogConfig);
    });

    this.dialogRef.close();
  }


  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  protected _onDestroy = new Subject<void>();

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}